import { render, staticRenderFns } from "./InspectionResults.vue?vue&type=template&id=27e924b4&scoped=true&"
import script from "./InspectionResults.vue?vue&type=script&lang=js&"
export * from "./InspectionResults.vue?vue&type=script&lang=js&"
import style0 from "./InspectionResults.vue?vue&type=style&index=0&id=27e924b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e924b4",
  null
  
)

export default component.exports